export const language: any ={
    cancel:"취소",
    ok:"예",
}